import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ModuleComponent} from './components/module/module.component';
import {MenuComponent} from './components/menu/menu.component';
import {PermissionComponent} from './components/permission/permission.component';
import {UserComponent} from './components/user/user.component';
import {RoleComponent} from './components/role/role.component';
import {RoleAddComponent} from './components/role/role-add/role-add.component';
import {UserEditComponent} from './components/user/user-edit/user-edit.component';
import {UserAddComponent} from './components/user/user-add/user-add.component';
import {RoleEditComponent} from './components/role/role-edit/role-edit.component';
import {InstitutionComponent} from './components/institution/institution.component';
import {InstitutionAddComponent} from './components/institution/institution-add/institution-add.component';
import {InstitutionEditComponent} from './components/institution/institution-edit/institution-edit.component';
import {BranchComponent} from './components/branch/branch.component';
import {BranchAddComponent} from './components/branch/branch-add/branch-add.component';
import {BranchEditComponent} from './components/branch/branch-edit/branch-edit.component';
import {UserProfileComponent} from './components/user/user-profile/user-profile.component';
import {UserInstitutionUpdateComponent} from './components/institution/user-institution-update/user-institution-update.component';
import {YearComponent} from './components/year/year.component';
import {CurrentYearComponent} from './components/current-year/current-year.component';
import {SubmenuComponent} from "./components/submenu/submenu.component";
import {SingleComponent} from "./components/single/single.component";
import {LabelComponent} from "./components/label/label.component";
import {SystemSettingsComponent} from "./components/system-settings/system-settings.component";
import {SystemLicenseComponent} from "./components/system-license/system-license.component";
import {SystemLicenseAddEditComponent} from "./components/system-license/system-license-add-edit/system-license-add-edit.component";
import {LicenseGuard} from "../../guards/license.guard";
import {CustomerLicenseComponent} from "./components/customer-license/customer-license.component";
import {
  AccountingSystemSettingsComponent
} from "./components/accounting-system-settings/accounting-system-settings.component";

const routes: Routes = [
  {
    path: '',
    //canActivateChild: [LicenseGuard],
    children: [
      {
        path: 'module',
        component: ModuleComponent
      },
      {
        path: 'label',
        component: LabelComponent
      },
      {
        path: 'single',
        component: SingleComponent
      },
      {
        path: 'menu',
        component: MenuComponent
      },
      {
        path: 'submenu',
        component: SubmenuComponent
      },
      {
        path: 'permission',
        component: PermissionComponent
      },

      {
        path: 'institutions',
        component: InstitutionComponent
      },
      {
        path: 'institutions/add',
        component: InstitutionAddComponent
      },
      {
        path: 'institutions/edit/:id',
        component: InstitutionEditComponent
      },
      {
        path: 'institution',
        component: UserInstitutionUpdateComponent
      },
      {
        path: 'branch',
        component: BranchComponent
      },
      {
        path: 'branch/add',
        component: BranchAddComponent
      },
      {
        path: 'branch/edit/:id',
        component: BranchEditComponent
      },

      {
        path: 'user',
        component: UserComponent
      },
      {
        path: 'user/add',
        component: UserAddComponent
      },
      {
        path: 'user/edit/:id',
        component: UserEditComponent
      },
      {
        path: 'user/profile/:id',
        component: UserProfileComponent
      },

      {
        path: 'role',
        component: RoleComponent
      },
      {
        path: 'role/add',
        component: RoleAddComponent
      },
      {
        path: 'role/edit/:id',
        component: RoleEditComponent
      },

      {
        path: 'year',
        component: YearComponent
      },
      {
        path: 'current/year',
        component: CurrentYearComponent
      },

      {
        path: 'system-settings',
        component: SystemSettingsComponent
      },
      {
        path: 'accounting-system-settings',
        component: AccountingSystemSettingsComponent
      },
	  {
        path: 'system-license',
        component: SystemLicenseComponent
      },
	  {
        path: 'system-license/add',
        component: SystemLicenseAddEditComponent
      },
	  {
        path: 'system-license/edit/:id',
        component: SystemLicenseAddEditComponent
      },
      {
        path: 'customer-license',
        component: CustomerLicenseComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SecurityRoutingModule { }
